import { AfterViewInit, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-table-dynamic',
  templateUrl: './table-dynamic.component.html',
  styleUrls: ['./table-dynamic.component.scss']
})
export class TableDynamicComponent implements AfterViewInit {

  @Input() columns: string[] = [];
  @Input() data: any[] = [];
  @Input() summary: string = "";
  @Input() pageIndex: number = 0;
  @Input() pageSize: number = 10;
  @Input() totalPages: number = 1;
  @Input() totalElements: number = 0;
  @Output() rowClicked = new EventEmitter<any>();
  @Output() onSortChange = new EventEmitter<any>();
  @Output() cellClicked = new EventEmitter<{ row: any, column: string }>();
  @Output() pageChanged = new EventEmitter<{ pageIndex: number, pageSize: number }>();

  displayedColumns: string[] = [];
  @Input() dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.dataSource.data = this.data;
    }
    if (changes['columns']) {
      this.displayedColumns = this.columns;
    }
  }

  onRowClick(row: any) {
    this.rowClicked.emit(row);
  }

  onCellClick(row: any, column: string) {
    this.cellClicked.emit({ row, column });
  }

  pageChangeEvent(event: any) {
    this.pageChanged.emit({ pageIndex: event.pageIndex, pageSize: event.pageSize });
  }

  handlefilter(column: any) {

    this.onSortChange.emit(column);
  }
}
